module.exports = __webpack_public_path__ + "img/glasses-7.9b95ab9a.svg";